__turbopack_context__.v({
  "displayStyle": "textInput-module-scss-module__5ZCsQG__displayStyle",
  "textInput": "textInput-module-scss-module__5ZCsQG__textInput",
});
